import axios from 'axios';

import {
	getStoredRoleData,
	getStoredTokenData
} from '../store/auth-context';
import { API_CONSTANTS } from './apiConstants';

const API_URL = API_CONSTANTS.API_URL;

export const getUserNotifications = async () => {
	const token = getStoredTokenData().token;
	const role = getStoredRoleData().role.toLocaleLowerCase();
	return axios.get(`${API_URL}/api/${role}/notifications`, {
		headers: {
			token: `${token}`
		}
	});
};

export const readUserNotifications = async (
	notificationId
) => {
	const token = getStoredTokenData().token;
	const role = getStoredRoleData().role.toLocaleLowerCase();
	const url = `${API_URL}/api/${role}/notification/${notificationId}`;
	let options = {
		headers: {
			token: `${token}`
		}
	};
	return axios.put(url, {}, options);
};

export const deleteNotification = async (
	ids
) => {
	const token = getStoredTokenData().token;
	const role = getStoredRoleData().role.toLocaleLowerCase();
	return axios.delete(
		`${API_URL}/api/${role}/notification`,

		{
			params: { ids },
			headers: {
				token: `${token}`
			}

		}
	);
};
